import {
    AfterViewInit,
    Directive,
    ElementRef,
    inject,
    Input,
    OnDestroy,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
    selector: '[libOverflowTooltip]',
    hostDirectives: [
        {
            directive: NgbTooltip,
            inputs: [
                'ngbTooltip: libOverflowTooltip',
                'placement: libOverflowTooltipPlacement',
                'container: libOverflowTooltipContainer',
            ],
        },
    ],
    standalone: true,
})
export class TelXLOverflowTooltipDirective implements AfterViewInit, OnDestroy {
    readonly #element = inject(ElementRef<HTMLElement>);
    readonly #tooltip = inject(NgbTooltip);

    @Input('libOverflowTooltip') tooltipText!: string;
    @Input() libOverflowTooltipPlacement = 'top';
    @Input() libOverflowTooltipContainer: string | null = 'body';

    resizeObserver!: ResizeObserver;

    ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.#element.nativeElement);

        setTimeout(() => this.update());
    }

    update() {
        const el = this.#element.nativeElement;
        const isOverflowing = el.scrollWidth > el.clientWidth;

        if (isOverflowing) {
            this.#tooltip.disableTooltip = false;
        } else {
            this.#tooltip.close();
            this.#tooltip.disableTooltip = true;
        }
    }

    ngOnDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
}
